import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, MapIcon, SparklesIcon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: DownloadIcon,
    number: '1',
    title: 'Descarga el Protocolo',
    description: 'Obtén acceso inmediato a la guía en PDF en tu celular o computador.'
  }, {
    icon: MapIcon,
    number: '2',
    title: 'Sigue el Mapa',
    description: 'Compra los ingredientes básicos y sigue el orden de comidas sugerido.'
  }, {
    icon: SparklesIcon,
    number: '3',
    title: 'Siente la Ligereza',
    description: 'Mira cómo tu abdomen baja y tu energía sube en las primeras 24 a 72 horas.'
  }];
  return <section className="w-full py-16 md:py-24" style={{
    backgroundColor: '#F0F7F4'
  }} data-id="element-95">
      <div className="max-w-5xl mx-auto px-4" data-id="element-96">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-97">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-center mb-4" style={{
          color: '#1A1A1A'
        }} data-id="element-98">
            ¿Cómo funciona?
          </h2>

          <p className="text-center text-lg mb-12" style={{
          color: '#4A4A4A'
        }} data-id="element-99">
            Solo 3 pasos simples:
          </p>

          <div className="grid md:grid-cols-3 gap-6 md:gap-8" data-id="element-100">
            {steps.map((step, index) => <motion.div key={index} className="relative bg-white rounded-3xl p-6 md:p-8 shadow-sm text-center" style={{
            border: '2px solid #C5DDD1'
          }} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.15
          }} data-id="element-101">
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-8 h-8 rounded-full flex items-center justify-center text-white font-bold" style={{
              backgroundColor: '#C9A96E'
            }} data-id="element-102">
                  {step.number}
                </div>

                <div className="w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-4 mt-2" style={{
              backgroundColor: '#C5DDD1'
            }} data-id="element-103">
                  <step.icon className="w-8 h-8" style={{
                color: '#1A1A1A'
              }} data-id="element-104" />
                </div>

                <h3 className="text-xl font-semibold mb-3" style={{
              color: '#1A1A1A'
            }} data-id="element-105">
                  {step.title}
                </h3>

                <p className="text-base" style={{
              color: '#4A4A4A'
            }} data-id="element-106">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}